<button 
    mat-mini-fab
    class="admin-theme"
    aria-label="Abmelden"
    [matMenuTriggerFor]="menu">
    <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #menu="matMenu" class="admin-theme">
    <button mat-menu-item (click)="logout()" aria-label="Abmelden">Abmelden</button>
</mat-menu>
